import React, { Dispatch, FC, SetStateAction } from "react";
import { WidgetLengthPickerLine } from "./WidgetLengthPickerLine";

export interface WidgetBorderWidthPickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly onChange: Dispatch<SetStateAction<string>>;
}

export const WidgetBorderWidthPicker: FC<WidgetBorderWidthPickerProps> = props => {
    return (
        <WidgetLengthPickerLine label={props.label ?? "Width"} value={props.value} defaultValue={props.defaultValue} onChange={props.onChange} />
    );
};